import React from "react"

import CardTravelIcon from "@mui/icons-material/CardTravel"
import LocalShippingIcon from "@mui/icons-material/LocalShipping"
import SettingsIcon from "@mui/icons-material/Settings"

import { parsePESToCardColors, PSE_TILE_VISUALS } from "../../utils/tiles"
import { Box } from "@mui/material"
import { COLORS } from "../../utils"
import ExecutionCard from "../Executions/ExecutionCard"

const PackagingExecutionCard = ({ item, onClick = () => { } }) => {
	const cardColors = parsePESToCardColors(item.lunchbag, item.nationalSend)
	const hasSubStatus = item.sections?.some(section => section.subStatus === "INSUFFICIENT_WEIGHT")

	return (
		<ExecutionCard
			item={{...item, isPackaging: true}}
			title={(
				<>
					<Box component="span" sx={sx.uniqueCodeTag}>
						{item.uniqueCode}
					</Box>
					<span>{item.recipeName}</span>
				</>
			)}
			chips={[
				...(item.nationalSend ? [{
					label: "Envoi en province",
					chipBackground: "transparent",
					chipFont: cardColors.dark,
					chipBorder: `1px solid ${cardColors.dark}`,
					icon: <LocalShippingIcon sx={{ color: cardColors.dark }} />
				}] : []),
				...(item.lunchbag ? [{
					label: "Lunchbag",
					chipBackground: "transparent",
					chipFont: cardColors.dark,
					chipBorder: `1px solid ${cardColors.dark}`,
					icon: <CardTravelIcon sx={{ color: cardColors.dark }} />
				}] : []),
				...(hasSubStatus ? [PSE_TILE_VISUALS.insufficientWeight] : []),
			]}
			cardSx={{ backgroundColor: cardColors.main, border: !item.lunchbag && !item.nationalSend ? "1px solid #DBDBDB" : "none" }}
			contentSx={{ backgroundColor: cardColors.light }}
			titleSx={sx.title}
			onClick={() => onClick(item)}
		>
			<Box sx={sx.chipsContainer}>
				{[
					...(item.packagingLineName ? [{
						icon: <SettingsIcon sx={{ color: COLORS.BLACK800, fontSize: "20px" }} />,
						label: item.packagingLineName || ""
					}] : []),
					{
						icon: <img alt="packaging-number" src="/icons/bowl.svg" style={{ width: "20px", height: "10px" }} />,
						label: (item.expectedPackagingNumber || 0) + " barquettes théorique"
					},
					{
						icon: <img alt="sections" src="/icons/border-all.svg" style={{ width: "20px", height: "20px" }} />,
						label: (item.sections?.length || 0) + " sections"
					}
				].map((info, index) => (
					<Box key={index} sx={{ ...sx.infosChip, backgroundColor: cardColors.default }}>
						{info.icon}
						<span>{info.label}</span>
					</Box>
				))}
			</Box>
		</ExecutionCard>
	)
}

const sx = {
	uniqueCodeTag: {
		backgroundColor: COLORS.WHITE,
		padding: "4px 8px",
		borderRadius: "8px",
		border: `1.5px solid ${COLORS.BLACK_200}`,
		fontSize: "16px",
		lineHeight: "24px",
		fontWeight: 400,
		color: COLORS.BLACK800,
	},
	title: {
		fontSize: "18px",
		fontWeight: 500
	},
	infosChip: {
		display: "flex",
		alignItems: "center",
		gap: "8px",
		fontSize: "16px",
		lineHeight: 1.5,
		color: COLORS.BLACK800,
		padding: "4px 8px",
		borderRadius: "8px",
	},
	chipsContainer: {
		display: "flex",
		gap: "12px",
		alignItems: "center",
	}
}
export default PackagingExecutionCard